module.exports = __webpack_public_path__ + "media/70_BL.5335b1b6.mp3";